import React from 'react';
import { bool, shape, string } from 'prop-types';

const TimerColor = ({
  className = 'icon',
  color = '#696f88',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M6.75 1.12793H11.25V2.62793H6.75V1.12793ZM8.25 10.8779V6.37793H9.75V10.8779H8.25ZM14.2725 5.91164L15.3375 4.84664C15.015 4.46414 14.6625 4.10414 14.28 3.78914L13.215 4.85414C12.0525 3.92414 10.59 3.36914 9 3.36914C5.2725 3.36914 2.25 6.39164 2.25 10.1191C2.25 13.8466 5.265 16.8691 9 16.8691C12.735 16.8691 15.75 13.8466 15.75 10.1191C15.75 8.53664 15.195 7.07414 14.2725 5.91164ZM3.75 10.1279C3.75 13.0304 6.0975 15.3779 9 15.3779C11.9025 15.3779 14.25 13.0304 14.25 10.1279C14.25 7.22543 11.9025 4.87793 9 4.87793C6.0975 4.87793 3.75 7.22543 3.75 10.1279Z" fill="currentColor" />
  </svg>
);

TimerColor.propTypes = {
  className: string,
  color: string,
  notUseClass: bool,
  style: shape({}),
};

export default TimerColor;
